export const ADMIN = "0bddd444-b41d-478e-a914-d0b4259495c5";
export const SHAREHOLDER = "90acae6e-7ac8-40e0-8965-62dbb3835115";



// WEBPACK FOOTER //
// ./src/constants/user-groups.js